import tokenService from '../_services/token.service';
import { decodeToken } from '../models/decode-token';

export const checkIfCandidateToken = () => {
  const token = tokenService.getLocalAccessToken();
  const decodedToken = decodeToken(token);
  return decodedToken?.candidate_id;
};
